import axios from 'axios';
import React from 'react';
import {withRouter} from 'react-router-dom';
import './Form.css';
import Navbar from './Navbar';

function Form(props) {
    const [name, setName] = React.useState('');
    const [category, setCategory] = React.useState('Misc');
    const [caption, setCaption] = React.useState('');
    const [url, setUrl] = React.useState('');

    const Post = (e) => {
        e.preventDefault();
        const apiUrl = process.env.REACT_APP_API_URL;
        axios({
            url: apiUrl + 'memes',
            method: 'POST',
            data: {
                name,
                category,
                caption,
                url
            }
        }).then((res, err)=>{
            if(err) throw err;
            props.history.push('/memes');
        }).catch(err=>{
            console.log("something went wrong!", err);
        });
    }

    return (
            <div>
                <h1 className="display-4 py-5 text-truncate" style={{fontWeight: 'bolder'}} >X-Meme</h1>
                <button onClick={()=>props.history.push('/memes')} type="submit" className="btn btn-success btn-lg" >Explore</button>
                <h1 className="display-4 py-2 text-truncate" style={{fontWeight: 'bolder'}} ></h1>
                <section id="cover" className="min-vh-10">
                <div id="cover-caption">
                    <div className="container">
                            <div className="row text-white">
                        <div className="col-xl-5 col-lg-6 col-md-8 col-sm-10 mx-auto text-center form p-4">
                        <h1 className="display-4 py-2 text-truncate">Create Meme</h1>
                        <div className="px-2">
                            <form onSubmit={Post} className="justify-content-center">
                                <div className="form-group">
                                    <br />
                                    <input value={name} onChange={(e)=>setName(e.target.value)} type="text" className="form-control" placeholder="Name" required />
                                </div>
                                <div className="form-group">
                                    <br />
                                    <select value={category} onChange={(e)=>setCategory(e.target.value)} className="form-control">
                                        <option>Coding</option>
                                        <option>Politics</option>
                                        <option>Sports</option>
                                        <option>Meme Lords</option>
                                        <option>Misc</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <br />
                                    <input value={caption} onChange={(e)=>setCaption(e.target.value)} type="text" className="form-control" placeholder="Caption" required />
                                </div>
                                <div className="form-group">
                                    <br />
                                    <input value={url} onChange={(e)=>setUrl(e.target.value)} type="text" className="form-control" placeholder="Meme Url" required />
                                </div>
                                <br />
                                <button type="submit" className="btn btn-primary btn-lg">Post</button>
                            </form>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
    )
}


export default withRouter(Form);